import $ from 'jquery';
import 'slick-carousel';

export default () => {
  $('.main-section__slider').each(function eachSliders() {
    const slider = $(this)
    let progressFunc;

    function start() {
      let i = 0;
      progressFunc = setInterval(() => {
        i+= 1;
        if (i <= 100) {
          $('.main-section__nav-proggress > span').css('width', `${i}%`);
        } else {
          clearInterval(progressFunc);
          slider.slick('slickNext');
        }
      }, 80);
    }

    function stop() {
      if (progressFunc) {
        clearInterval(progressFunc);
      }
      $('.main-section__nav-proggress > span').css('width', 0);
    }

    $(this).on('init', (event, slick) => start())

    $(this).slick({
      slidesToShow: 1,
      fade: true,
      speed: 800,
      arrows: true,
      infinite: true,
      dots: false,
      rows: 0,
      prevArrow: $('.main-section__arrow.prev-arrow').html('<div class="main-arrow prev-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M11.7583 0L13.7417 1.98333L7.22501 8.5L13.7417 15.0167L11.7583 17L3.25835 8.5L11.7583 0Z" /></svg></div>'),
      nextArrow: $('.main-section__arrow.next-arrow').html('<div class="main-arrow next-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M5.2417 0L3.25837 1.98333L9.77503 8.5L3.25837 15.0167L5.2417 17L13.7417 8.5L5.2417 0Z" /></svg></div>'),
      asNavFor: '.main-section__nav-slider',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: true,
          }
        }
      ]
    });

    $(this).on('beforeChange', (event, slick, currentSlide, nextSlide) => stop())
    $(this).on('afterChange', (event, slick, currentSlide) => start())

    $('.main-section__nav-slide, .main-section__arrow').on('click', () => {
      $(this).on('beforeChange', (event, slick, currentSlide, nextSlide) => stop())
      $(this).on('afterChange', (event, slick, currentSlide) => stop())
    })
  })

  $('.main-section__nav-slider').slick({
    slidesToShow: 4,
    speed: 800,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    rows: 0,
    asNavFor: '.main-section__slider',
    useTransform: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })

  $('.article__slider').slick({
    slidesToShow: 1,
    fade: true,
    speed: 800,
    arrows: true,
    infinite: true,
    dots: false,
    rows: 0,
    prevArrow: '<div class="article__arrow prev-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M11.7583 0L13.7417 1.98333L7.22501 8.5L13.7417 15.0167L11.7583 17L3.25835 8.5L11.7583 0Z" /></svg></div>',
    nextArrow: '<div class="article__arrow next-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M5.2417 0L3.25837 1.98333L9.77503 8.5L3.25837 15.0167L5.2417 17L13.7417 8.5L5.2417 0Z" /></svg></div>'
  })

  $('.our-team__list').slick({
    slidesToShow: 4,
    speed: 800,
    arrows: true,
    infinite: true,
    dots: false,
    rows: 0,
    prevArrow: '<div class="article__arrow prev-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M11.7583 0L13.7417 1.98333L7.22501 8.5L13.7417 15.0167L11.7583 17L3.25835 8.5L11.7583 0Z" /></svg></div>',
    nextArrow: '<div class="article__arrow next-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M5.2417 0L3.25837 1.98333L9.77503 8.5L3.25837 15.0167L5.2417 17L13.7417 8.5L5.2417 0Z" /></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  })

  $('.about-reviews__list').slick({
    slidesToShow: 2,
    speed: 800,
    arrows: true,
    infinite: true,
    dots: false,
    rows: 0,
    prevArrow: '<div class="article__arrow prev-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M11.7583 0L13.7417 1.98333L7.22501 8.5L13.7417 15.0167L11.7583 17L3.25835 8.5L11.7583 0Z" /></svg></div>',
    nextArrow: '<div class="article__arrow next-arrow"><svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><path d="M5.2417 0L3.25837 1.98333L9.77503 8.5L3.25837 15.0167L5.2417 17L13.7417 8.5L5.2417 0Z" /></svg></div>',
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        }
      }
    ]
  })
}


// WEBPACK FOOTER //
// app/scripts/components/sliders.js